import type { ReturnRequestStatusDto } from "@babackapp/private-api-client";

export function isCancellable(status: ReturnRequestStatusDto): boolean {
  return (
    !status.cancelled.done &&
    !status.treatedMerchant.done &&
    !status.treatedLogistician.done &&
    !status.partiallyTreatedMerchant.done &&
    !status.partiallyTreatedLogistician.done &&
    !status.resolved.done
  );
}
